import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0a7c3eaf"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a7c3eaf')) {
      api.createRecord('0a7c3eaf', component.options)
    } else {
      api.reload('0a7c3eaf', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0a7c3eaf", function () {
      api.rerender('0a7c3eaf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/public/404/index.vue"
export default component.exports